import image from "../../../image/image-auth-2.jpg";
import "./BodyAuth.scss";

export const BodyAuthComponents = ({ children, className = "" }) => {
  return (
    <>
      <div className="flex flex-row h-screen">
        <div className={`w-2/5 md:w-full h-full ${className}`}>{children}</div>
        <div className="w-3/5 flex justify-end md:hidden md:w-0">
          {" "}
          <img src={image} alt="image-login" className="image-auth md:hidden" />
        </div>
      </div>
    </>
  );
};
